import { css } from '@emotion/css'
import { spacing, fontWeight, borderRadius } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import { colors } from '../../../themes'

const styles = {
  wrapper: css({
    display: 'flex',
    alignItems: 'center',
    color: colors.jumbo,
    padding: shorthandHelper([spacing.small, spacing.default]),
    fontWeight: fontWeight.regular,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    userSelect: 'none',

    '&:first-child': {
      borderTopLeftRadius: borderRadius.default,
      borderTopRightRadius: borderRadius.default,

      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 30,
        width: 8,
        height: 8,
        backgroundColor: colors.white,
        borderLeft: `1px solid ${colors.mystic}`,
        borderTop: `1px solid ${colors.mystic}`,
        transform: 'rotate(45deg) translateY(-7px)',
      },
    },

    '&:last-child': {
      borderBottomLeftRadius: borderRadius.default,
      borderBottomRightRadius: borderRadius.default,
    },

    '&:first-child:hover::before': {
      backgroundColor: colors.athensGray,
    },

    '&:hover': {
      backgroundColor: colors.athensGray,
    },
  }),

  selected: css({
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold,
  }),

  disabled: css({
    pointerEvents: 'none',

    '& > *': {
      opacity: 0.3,
    },
  }),
}

export default styles
